export default {
    TENDER_BUD: { value: 'TENDER_BUD',  label: "青青绿芽" },
    LEAFY: { value: 'LEAFY',  label: "枝繁叶茂" },
    FLOWERS: { value: 'FLOWERS',  label: "花开朵朵" },
    RIPENING: { value: 'RIPENING',  label: "累累硕果" },
}
